module.exports = __webpack_public_path__ + "static/media/mastercard-logo.b7e2bd66.svg";